if (typeof document === "undefined") return;
var extractCssCreateStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject, fetchPriority
) {
	var linkTag = document.createElement("link");
linkTag.setAttribute("data-vanilla-extract", "true");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;


if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
  linkTag.crossOrigin = 'anonymous';
}


	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var extractCssFindStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var extractCssLoadStylesheet = function (chunkId, fetchPriority) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (extractCssFindStylesheet(href, fullhref)) return resolve();
		extractCssCreateStylesheet(chunkId, fullhref, null, resolve, reject, fetchPriority);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	3808: 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises, fetchPriority) {
	var cssChunks = {
1021: 1,
1168: 1,
1182: 1,
1228: 1,
1270: 1,
163: 1,
164: 1,
1661: 1,
1782: 1,
2119: 1,
2450: 1,
2590: 1,
2773: 1,
2807: 1,
2853: 1,
2866: 1,
2867: 1,
2911: 1,
3024: 1,
3191: 1,
3220: 1,
3455: 1,
3604: 1,
3645: 1,
365: 1,
3662: 1,
3666: 1,
366: 1,
3741: 1,
3820: 1,
3963: 1,
4174: 1,
4397: 1,
4449: 1,
4582: 1,
4775: 1,
4873: 1,
4899: 1,
4960: 1,
5003: 1,
5014: 1,
5018: 1,
5024: 1,
5184: 1,
5259: 1,
541: 1,
5524: 1,
5537: 1,
5698: 1,
584: 1,
5902: 1,
5976: 1,
5985: 1,
6006: 1,
617: 1,
6307: 1,
6325: 1,
6386: 1,
6436: 1,
6472: 1,
6629: 1,
6723: 1,
6829: 1,
6938: 1,
7051: 1,
70: 1,
7116: 1,
7154: 1,
7210: 1,
7329: 1,
7367: 1,
7537: 1,
7746: 1,
7905: 1,
8029: 1,
8046: 1,
8143: 1,
814: 1,
8166: 1,
8217: 1,
8253: 1,
8387: 1,
8517: 1,
8723: 1,
8754: 1,
8797: 1,
8985: 1,
916: 1,
9297: 1,
9425: 1,
9564: 1,
9866: 1,
9886: 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = extractCssLoadStylesheet(chunkId, fetchPriority).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

// no hmr
// no prefetch
// no preload